module.exports = __webpack_public_path__ + "img/u287.d4ee92af.png";